import { Drawer } from 'antd';
import { getCompareSurveyReportExel } from 'clients/dashboardClients';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import { useApiLoaderStore } from 'store/apiLoderStore';
import { useFilterStore } from 'store/filterStore';
import { useNewStore } from 'store/newStore';
import { useToastStore } from 'store/toastStore';
import styles from './exportFileDialogue.module.scss';
type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  startDate: any;
  endDate: any;
};
function CompareSurveyReportDrawer(props: Props) {
  const { isOpen, setIsOpen, startDate, endDate } = props;
  const [distinctGrades, lowerLimit, higherLimit, selectedDataSouce] =
    useNewStore((state) => [
      state.distinctGrades,
      state.lowerLimit,
      state.higherLimit,
      state.selectedDataSouce,
    ]);
  const showLoader = useApiLoaderStore((state) => state.showLoader);
  const showToast = useToastStore((state) => state.showToast);
  const filterDto = useFilterStore((state) => state.filterDto);
  const [gradeOptions, setGradeOptions] = useState([{ label: '', value: '' }]);
  const [subjectOptions, setSubjectOptions] = useState([
    { label: '', value: '' },
  ]);
  const [surveyOptions, setSurveyOptions] = useState([
    { label: '', value: '' },
  ]);
  const [selectedGrade, setSelectedGrade] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [selectedFirstSurveyId, setSelectedFirstSurveyId] = useState('');
  const [selectedSecondSurveyId, setSelectedSecondSurveyId] = useState('');
  useEffect(() => {
    if (distinctGrades && distinctGrades.keys()) {
      const gradeArray = Array.from(distinctGrades.keys()).map((key: any) => ({
        label: key,
        value: key,
      }));
      setGradeOptions(gradeArray);
      setSelectedGrade(gradeArray[0].value);
    }
  }, [distinctGrades, setGradeOptions, setSelectedGrade]);
  useEffect(() => {
    if (distinctGrades && selectedGrade && distinctGrades.get(selectedGrade)) {
      const subjectArray = Array.from(
        distinctGrades.get(selectedGrade).keys()
      ).map((key: any) => ({
        label: key,
        value: key,
      }));
      setSubjectOptions(subjectArray);
      setSelectedSubject(subjectArray[0].value);
    }
  }, [distinctGrades, setSubjectOptions, selectedGrade, setSelectedSubject]);
  useEffect(() => {
    if (distinctGrades && selectedGrade && selectedSubject) {
      const surveyArray = distinctGrades.get(selectedGrade).get(selectedSubject)
        ? distinctGrades
            .get(selectedGrade)
            .get(selectedSubject)
            .map((key: any) => ({
              label: key,
              value: key,
            }))
        : [];
      setSurveyOptions(surveyArray);
    }
  }, [distinctGrades, selectedGrade, selectedSubject, setSurveyOptions]);
  function onClose() {
    setIsOpen(false);
  }
  function onDownloadButtonClicked() {
    onClose();
    const body = {
      selectedSessionNames: filterDto ? filterDto.selectedSessionNames : [],
      selectedCountries: filterDto ? filterDto.selectedCountries : [],
      selectedStates: filterDto ? filterDto.selectedStates : [],
      selectedDistricts: filterDto ? filterDto.selectedDistricts : [],
      selectedBlocks: filterDto ? filterDto.selectedBlocks : [],
      selectedClusters: filterDto ? filterDto.selectedClusters : [],
      selectedSchoolGroups: filterDto ? filterDto.selectedSchoolGroups : [],
      selectedSchoolIds: filterDto ? filterDto.selectedSchoolIds : [],
      selectedGrades: filterDto ? filterDto.selectedGrades : [],
      lowerLimit: lowerLimit,
      upperLimit: higherLimit,
      startDate: startDate.unix(),
      endDate: endDate.unix(),
      dataSource: selectedDataSouce,
      grade: selectedGrade,
      subject: selectedSubject,
      firstSurveyId: selectedFirstSurveyId,
      secondSurveyId: selectedSecondSurveyId,
    };
    showLoader(true);
    getCompareSurveyReportExel(body, showToast).then((response: any) => {
      showLoader(false);
      if (response) {
        response.blob().then((blob: any) => {
          if (blob && blob.size > 0) {
            const fileURL = window.URL.createObjectURL(blob);
            const elem = document.createElement('a');
            elem.href = fileURL;
            elem.download = 'report.xlsx';
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
          }
        });
      }
    });
  }
  return (
    <Drawer
      title="Compare survey report"
      onClose={onClose}
      open={isOpen}
      bodyStyle={{ padding: '0' }}
    >
      <div className="w-100 h-100 flex-column">
        <div className="w-100 h-100" style={{ padding: '1rem' }}>
          <div className={styles.reportTemplateContainer}>
            <label className={styles.widthFifty}>Grades :</label>
            <div style={{ width: '52%' }}>
              <Select
                value={{
                  label: selectedGrade,
                  value: selectedGrade,
                }}
                options={gradeOptions}
                placeholder="Select grade"
                onChange={(values: any) => {
                  setSelectedGrade(values!.value);
                  setSelectedSubject('');
                  setSelectedFirstSurveyId('');
                  setSelectedSecondSurveyId('');
                }}
              />
            </div>
          </div>

          <div className={styles.reportTemplateContainer}>
            <label className={styles.widthFifty}>Subjects :</label>
            <div style={{ width: '52%' }}>
              <Select
                value={{
                  label: selectedSubject,
                  value: selectedSubject,
                }}
                options={subjectOptions}
                placeholder="Select subject"
                onChange={(values: any) => {
                  setSelectedSubject(values!.value);
                  setSelectedFirstSurveyId('');
                  setSelectedSecondSurveyId('');
                }}
              />
            </div>
          </div>
          <div className={styles.reportTemplateContainer}>
            <label className={styles.widthFifty}>{'First survey id :'}</label>
            <div style={{ width: '52%' }}>
              <Select
                value={{
                  label: selectedFirstSurveyId,
                  value: selectedFirstSurveyId,
                }}
                options={surveyOptions}
                placeholder="Select first surveyid"
                onChange={(values: any) =>
                  setSelectedFirstSurveyId(values!.value)
                }
              />
            </div>
          </div>
          <div className={styles.reportTemplateContainer}>
            <label className={styles.widthFifty}>{'Second survey id :'}</label>
            <div style={{ width: '52%' }}>
              <Select
                value={{
                  label: selectedSecondSurveyId,
                  value: selectedSecondSurveyId,
                }}
                options={surveyOptions}
                placeholder="Select second surveyid"
                onChange={(values: any) =>
                  setSelectedSecondSurveyId(values!.value)
                }
              />
            </div>
          </div>
        </div>
        <div
          className="flex-align-center "
          style={{
            justifyContent: 'space-between',
            borderTop: '1px solid lightgray',
            padding: '1rem',
          }}
        >
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => onDownloadButtonClicked()}>
            Download
          </Button>
        </div>
      </div>
    </Drawer>
  );
}

export default CompareSurveyReportDrawer;
